require('./base.js');
require('../../../public/javascripts/jquery/ui/jquery.ui.core.js')
require('../../../public/javascripts/jquery/ui/jquery.ui.widget.js')
require('../../../public/javascripts/jquery/ui/jquery.ui.tabs.js')
require('./js_maps.js');
require('./photos_view.js');

require('../../../public/javascripts/jquery/jquery.livesearch.js')
require('../../../public/javascripts/groups/show.js')



// WEBPACK FOOTER //
// ./app/assets/javascripts/groups-show.js